import { createFileRoute } from '@tanstack/react-router'
import { StaffAsetDesa } from '../../../../components/StaffAsetDesa'

export const Route = createFileRoute('/desa/$slug/dashboard/administrasi')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <StaffAsetDesa desaId={desaId} />
  },
})
